import chatbotRequest from '@/service/channel/http'
import type { SendRoomMessageReq, SendRoomMessageRes } from '../type/sendRoomMessage'

export function sendRoomMessageApi(data: SendRoomMessageReq): Promise<SendRoomMessageRes> {
    return chatbotRequest<SendRoomMessageRes, SendRoomMessageReq, SendRoomMessageRes>({
        url: '/api/room/message',
        method: 'post',
        data,
    })
}